import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../atoms/button/button';
import { Header } from '../../atoms/header/header';
import { Text } from '../../atoms/text/text';

import MobileLoginPane from './assets/mobile-login-pane.svg?react';

type LoggedOutProps = {
  readonly handleSignIn?: () => void;
  readonly automaticSso: boolean;
};

export function LoggedOut({ automaticSso, handleSignIn }: LoggedOutProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center">
      <Header className="mb-2" level="h1">
        {t('ui-components.loggedOut.title')}
      </Header>
      {automaticSso && (
        <Text className="mb-1" size="lg">
          {t('ui-components.loggedOut.ssoMessage')}
        </Text>
      )}
      <MobileLoginPane></MobileLoginPane>
      {handleSignIn && (
        <Button onClick={handleSignIn} size="lg">
          {t('ui-components.loggedOut.goToLogin')}
        </Button>
      )}
    </div>
  );
}
